import React from 'react';

const VARIANTS = {
  green: 'duo-stat-card--green',
  blue: 'duo-stat-card--blue',
  orange: 'duo-stat-card--orange',
};

const DuoStatCard = ({ variant = 'green', icon, label, value, meta, loading }) => {
  return (
    <div className={`duo-stat-card ${VARIANTS[variant] || VARIANTS.green}`}>
      <div className={`duo-stat-card__icon duo-stat-card__icon--${variant}`}>
        <i className={icon} aria-hidden />
      </div>
      <p className="duo-stat-card__label">{label}</p>
      {loading ? (
        <div className="duo-skeleton" style={{ width: '70%', height: '2rem' }} />
      ) : (
        <p className="duo-stat-card__value">{value ?? '—'}</p>
      )}
      {meta && !loading ? <p className="duo-stat-card__meta">{meta}</p> : null}
    </div>
  );
};

export default DuoStatCard;
